
    window.__HOST__ = 'base';
    import '/src/main.tsx';
  